import { API } from "services/enum/api";
import { fetcher } from "services/fetcher";
import useSWR from "swr";
import urlcat from "urlcat";

type UseCompanyReturnType = {
  isLoading: boolean;
  data: Company;
  mutate: () => void;
  isValidating: boolean;
  error: any;
  isEmpty: boolean;
  isError: any;
  [key: string]: any;
};

export function useCompany(slug: string): UseCompanyReturnType {
  const { data, mutate, error, isLoading, isValidating } = useSWR(urlcat(API.GET_COMPANY_BY_SLUG, { slug }), fetcher);
  const company = data?.data?.[0] || {};

  return {
    data: company,
    isLoading,
    isError: error,
    isEmpty: !error && !isLoading && !data,
    mutate,
    isValidating,
    error,
  }
};